import { render, staticRenderFns } from "./AngleField.vue?vue&type=template&id=43c92fa5&lang=pug&"
import script from "./AngleField.vue?vue&type=script&lang=js&"
export * from "./AngleField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c92fa5')) {
      api.createRecord('43c92fa5', component.options)
    } else {
      api.reload('43c92fa5', component.options)
    }
    module.hot.accept("./AngleField.vue?vue&type=template&id=43c92fa5&lang=pug&", function () {
      api.rerender('43c92fa5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/AngleField.vue"
export default component.exports